(function () {
  var IDS = ['zgoda-cyfrowa-checkbox', 'zgoda-cyfrowa-checkbox-drawer'];

  function getButtonsFor(checkboxEl) {
    var els = [];
    if (checkboxEl.id === 'zgoda-cyfrowa-checkbox') {
      // Strona produktu — formularze Buy Buttons
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        form.querySelectorAll('button[type="submit"], shopify-accelerated-checkout').forEach(function (b) {
          els.push(b);
        });
      });
    } else {
      // Cart drawer
      var checkoutBtn = document.getElementById('checkout');
      if (checkoutBtn) els.push(checkoutBtn);
      document.querySelectorAll('shopify-accelerated-checkout-cart').forEach(function (b) {
        els.push(b);
      });
    }
    return els;
  }

  function applyBlocked(checkboxEl, blocked) {
    getButtonsFor(checkboxEl).forEach(function (el) {
      if (el.tagName === 'BUTTON') {
        if (blocked) {
          el.setAttribute('disabled', 'disabled');
          el.dataset.zgodaBlocked = '1';
        } else if (el.dataset.zgodaBlocked === '1') {
          el.removeAttribute('disabled');
          delete el.dataset.zgodaBlocked;
        }
      } else {
        // custom elementy z zamkniętym shadow DOM (np. shopify-accelerated-checkout-cart)
        el.style.pointerEvents = blocked ? 'none' : '';
        el.style.opacity = blocked ? '0.5' : '';
      }
    });
  }

  function syncCheckbox(el) {
    var checked = sessionStorage.getItem('zgodaCyfrowa') === '1';
    el.checked = checked;
    applyBlocked(el, !checked);
  }

  // Odświeża stan każdego checkboxa aktualnie obecnego w DOM
  // (obsługuje zarówno pierwsze wyrenderowanie, jak i przeładowania drawera przez AJAX)
  function syncAll() {
    IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) syncCheckbox(el);
    });
  }

  // Delegacja zdarzeń na poziomie document — działa nawet gdy checkbox
  // zostanie usunięty i odtworzony przez Section Rendering API
  document.addEventListener('change', function (e) {
    if (IDS.indexOf(e.target.id) === -1) return;

    var checked = e.target.checked;
    sessionStorage.setItem('zgodaCyfrowa', checked ? '1' : '0');

    IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.checked = checked;
        applyBlocked(el, !checked);
      }
    });

    if (checked) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: 'Zgoda na treść cyfrową zaakceptowana: ' + new Date().toISOString()
        })
      });
    }
  });

  syncAll();

  // Drawer/produkt mogą się przerenderować bez odpalenia 'change' — pilnujemy DOM
  new MutationObserver(syncAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:updated', syncAll);
})();